import { useContext } from "react"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"

function SvgComponent(props: any) {
    const {info: {theme}} = useContext(AppInfoContext)

    return (
        <svg
            width={18}
            height={17}
            viewBox="0 0 18 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M9.375 11.754a3.906 3.906 0 107.813 0 3.906 3.906 0 00-7.813 0zm0 0c0-.88.29-1.691.781-2.344V2.379m-.781 9.375c0 .645.156 1.253.433 1.79-.658.555-2.178.944-3.949.944-2.373 0-4.296-.7-4.296-1.562V2.379m8.593 0c0 .863-1.924 1.562-4.297 1.562-2.373 0-4.296-.7-4.296-1.562m8.593 0c0-.863-1.924-1.563-4.297-1.563-2.373 0-4.296.7-4.296 1.563m0 7.031c0 .863 1.923 1.563 4.296 1.563 1.71 0 3.187-.364 3.879-.89m.418-4.188c0 .862-1.924 1.562-4.297 1.562-2.373 0-4.296-.7-4.296-1.562"
                stroke={props.isHover ? '#fff' : theme["#0D968F"]}
                strokeWidth={1.5625}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}
  
  export default SvgComponent